import { Stack } from "@chakra-ui/react";
import { redirect } from "react-router-dom";

import { RoutesMap } from "../../routes.tsx";
import { PageHeader } from "../../components/shared/PageHeader";
import { useSbpTransferStore } from "../../store/sbpTransferStore.ts";
import { SbpTransferBanksPageContent } from "../../components/features/SbpTransfer";

export const SbpTransferBanksPage = () => {
  return (
    <Stack spacing={0} h="100svh">
      <PageHeader title="Перевести" link={RoutesMap.sbpTransfer.index} />

      <SbpTransferBanksPageContent />
    </Stack>
  );
};

SbpTransferBanksPage.loader = () => {
  const { amount, term } = useSbpTransferStore.getState();

  if (!amount || !term) {
    return redirect(RoutesMap.index);
  }

  return null;
};
